//PRODUZIONE

export function getApiUrl () {
    return window.location.origin + "/tassa-auto/api";
}

export function getMainUrl () {
    return window.location.origin + "/tassa-auto";
}

export function getApiAuthenticateUrl () {
    return window.location.origin + "/tassa-auto";
}

export function getPath(){
    return "/tassa-auto";
}

export function getPaymentMode(){
    return "produzione";
}